import React from 'react';
import CardButton from '../CardButton/CardButton';
import './TutorDaySlide.css';
import { cosmosTrackService } from '../../../../../cosmosTracking/cosmosTrackService';
import {tutor_of_the_day, View_checklist} from '../../../../../cosmosTracking/cosmosEvents';
import { SOURCE_HOME, directDeepLink } from '../../../util';
import tutorsale from '../../../../../assets/images/ttols-to-boost-2026.png';
import holippl from '../../../../../assets/images/holi-people.png';
function TutorDaySlide(props) {
	const { data, rewardText } = props;
	return (
		<div className="slideCard slideCardTutor">
			<div className="cardBody">
				{/* <img src={holippl} className='overlay-image' /> */}
				
				<img className="tutor-top-img" src={tutorsale} alt="tutor of day"/>
				<hr className='leader-board-top-img-border' />
				
				<div className="tutorData" onClick={() => {cosmosTrackService(tutor_of_the_day);directDeepLink(data?.deeplink, SOURCE_HOME);}}
					 deeplink={data?.deeplink}>
					<img src={data?.orgLogo} width={60} alt="tutor" height={60} />
					<h4>{data?.orgName}</h4>
				</div>
				<CardButton text={'Be the one '} className={'btn-action'} eventCallback={() => {cosmosTrackService(tutor_of_the_day);}} deeplink={data?.deeplink}
				/>
			</div>
		</div>
	);
}

export default TutorDaySlide;
